import { IconPropsType } from '..';

export const Eth = ({ ...props }: IconPropsType) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26667)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#627EEA"
      />
      <g clipPath="url(#clip1_188_26667)">
        <path
          d="M49.7977 10L25 50.7721L49.7977 39.4995V10Z"
          fill="#FEFEFE"
        />
        <path
          d="M49.7979 10L74.6008 50.7721L49.7979 39.4995V10Z"
          fill="#BFCAF5"
        />
        <path
          d="M74.6008 50.7721L49.7979 39.4995V50.7721H74.6008Z"
          fill="#8096ED"
        />
        <path
          d="M74.6008 55.3727L49.7979 89.9999V69.771L74.6008 55.3727Z"
          fill="#BFCAF5"
        />
        <path
          d="M25 55.3727L49.7977 89.9999V69.771L25 55.3727Z"
          fill="#FEFEFE"
        />
        <path
          d="M25 50.7721L49.7977 65.1704V50.7721H25Z"
          fill="#C1CBF6"
        />
        <path
          d="M74.6008 50.7721L49.7979 65.1704V50.7721H74.6008Z"
          fill="#8096ED"
        />
        <path
          d="M25 50.7721L49.7977 39.4995V50.7721H25Z"
          fill="#C1CBF6"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_188_26667">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_188_26667">
        <rect
          width="49.6006"
          height="80"
          fill="white"
          transform="translate(25 10)"
        />
      </clipPath>
    </defs>
  </svg>
);
